module.exports = __webpack_public_path__ + "static/media/015.dcfe61b1.jpg";